import * as React from 'react'
import { connect } from 'react-redux'

import Feedback from '../../screens/Feedback/index'
import { feedbkList, slectedPage, feedbackSearch, searchUser, fetchFeedbckById, feedbackPagitn } from './action'
class FeedbackContainer extends React.Component<Props, State>{
    render() {
        return <Feedback
            feedbkList={this.props.feedbkList}
            fedbckDtlsList={this.props.fedbckDtlsList}
            fedbckDtlsCount={this.props.fedbckDtlsCount}
            slectedPage={this.props.slectedPage}
            searchUser={this.props.searchUser}
            UsersList={this.props.UsersList}
            fetchFeedbckById={this.props.fetchFeedbckById}
            FeedBckSearchList={this.props.FeedBckSearchList}
            FeedBckSearchCount={this.props.FeedBckSearchCount}
            feedbackPagitn={this.props.feedbackPagitn}
        // feedbackSearch={this.props.feedbackSearch}
        />
    }
}
function bindAction(dispatch) {
    return {
        feedbkList: () => {
            dispatch(feedbkList())
        },
        slectedPage: (value) => {
            dispatch(slectedPage(value))
        },
        searchUser: (value) => {
            dispatch(searchUser(value))
        },
        fetchFeedbckById: (value) => {
            dispatch(fetchFeedbckById(value))
        },
        feedbackPagitn: (value) => {
            dispatch(feedbackPagitn(value))
        }
    }
}
function mapStateToProps(state) {
    // console.log("UsersList============", state.FeedbackReducer.FeedBckSearchCount)
    return {
        fedbckDtlsList: state.FeedbackReducer.fedbckDtlsList,
        fedbckDtlsCount: state.FeedbackReducer.fedbckDtlsCount,
        UsersList: state.FeedbackReducer.UsersList,
        FeedBckSearchList: state.FeedbackReducer.FeedBckSearchList,
        FeedBckSearchCount: state.FeedbackReducer.FeedBckSearchCount
    }
}

export default connect(mapStateToProps, bindAction)(FeedbackContainer)